<template lang="html">

    <div>
        <!-- page header -->
        <!-- <page-heading pageTitle="PIM-CAMPAIGN-TITLE">asfsf</page-heading> -->
        <page-heading pageTitle="PIM-CAMPAIGN-TITLE" :pageTitle2="$t(pageTitle)"></page-heading>

        <div class="box">


            <template v-if="isLoading">

                <loading-indicator></loading-indicator>

            </template>

            <template v-else>


                <section>

                    <!--STATUS -->
                    <form-input :class="['bg-light grey rounded', { 'is-published': campaign.status.name == 'PUBLISHED' }]" label="PIM-CAMPAIGN-STATUS" inputType="select" :selectOptions="Object.values(campaignStatus)" v-model="campaign.status"></form-input>

                </section>

                <section>
                    <!-- Kategorie -->
                    <div class="control" v-if="userRole == 'Administrator' || userRole === 'Administrator JTM'">

                        <div class="control-label">
                            <lang labelKey="PIM-CAMPAIGN-CATEGORY" class="label"></lang>
                        </div>

                        <div class="control">

                            <multiselect
                                v-model="campaign.category"
                                :options="Object.values(offerCategories)"
                                :custom-label="customCategoryLabel"
                                :allow-empty="true"
                                :multiple="false"
                                selected-label="aktiv"
                                deselect-label="Klick um abzuwählen"
                                select-label="Klick für Auswahl"
                                placeholder="Bitte Kategorie auswählen"
                                label="name"
                                track-by="id"
                                class="small">

                                <span slot="noOptions">Keine Einträge vorhanden</span>
                                <span slot="noResult">Ihre Suche ergab leider keine Treffer.</span>

                            </multiselect>

                        </div>

                    </div>

                </section>

                <!-- VOUCHER -->
                <section v-if="campaign.type.name != 'AEP' && campaign.type.name != 'LOYALTY_POINTS'">

                    <div class="control">
                        <div class="control-label">
                            <label-name labelKey="PIM-CAMPAIGN-HAS_VOUCHER"></label-name>
                        </div>
                        <div class="control">
                            <b-switch v-model.sync="campaign.hasVoucher" type="primary" size="small"></b-switch>
                        </div>
                    </div>

                    <template v-if="campaign.hasVoucher">

                      <div style="display: flex; max-width:800px;">
                          <form-input inputType="text" v-model="campaign.voucherCode" label="PIM-CAMAPGIN-VOUCHER_CODE" style="margin-right:4px;"></form-input>
                          <a class="button is-primary" @click="makeid()"><lang labelKey="PIM-CAMPAIGN-BTN-GENERATE_CODE"></lang></a>
                      </div>

                      <div style="display: flex; max-width:800px; margin-bottom: 16px;">
                          <form-input inputType="text" v-model="campaign.usageLimit" label="PIM-CAMAPGIN-USAGE_LIMIT"></form-input>
                      </div>

                      <div style="display: flex; max-width:800px; margin-bottom: 16px;">
                          <form-input inputType="text" v-model="campaign.usageLimitPerUser" label="PIM-CAMAPGIN-USAGE_LIMIT_PER_USER"></form-input>
                      </div>

                      <div class="control" v-if="(campaign.type.name == 'OFFER_PRICE' || campaign.type.name == 'DISCOUNT')">
                          <div class="control-label">
                              <label-name labelKey="PIM-CAMPAIGN-IS_ACTIVATABLE"></label-name>
                          </div>
                          <div class="control">
                              <b-switch v-model.sync="campaign.isActivatable" type="primary" size="small"></b-switch>
                          </div>
                      </div>

                    </template>

                </section>

                <!-- GENERAL SETTINGS -->
                <section>

                    <div class="sectionLabel">
                        <lang labelKey="PIM-CAMPAIGN-SECTION-LABEL-GENERAL_SETTINGS"></lang>
                    </div>

                    <form-input label="PIM-CAMPAIGN-TYPE" inputType="text" :placeholder="$t('PIM-CAMPAIGNS-TYPE-'+campaign.type.name)" :isReadOnly="true"></form-input>

                    <form-input label="PIM-CAMPAIGN-DESCRIPTION" inputType="textarea" v-model="campaign.description"></form-input>

                    <div class="control">
                        <div class="control-label">
                            <label-name labelKey="PIM-CAMPAIGN-VALID_FROM"></label-name>
                        </div>
                        <div class="control">
                            <datepicker placeholder="Startdatum wählen" :options="datePickerOptions" v-model="campaign.validFrom"></datepicker>
                        </div>
                    </div>

                    <div class="control">
                        <div class="control-label">
                            <label-name labelKey="PIM-CAMPAIGN-VALID_TO"></label-name>
                        </div>
                        <div class="control">
                            <datepicker placeholder="Enddatum wählen" :options="datePickerOptions" v-model="campaign.validTo"></datepicker>
                        </div>
                    </div>

                </section>


                <!-- DISCOUNT SETTINGS -->
                <section v-if="campaign.type.name == 'DISCOUNT' || campaign.type.name == 'CART_DISCOUNT' || campaign.type.name == 'LOYALTY_POINTS'">

                    <div class="sectionLabel">
                        <lang labelKey="PIM-CAMPAIGN-SECTION-LABEL-DISCOUNT_SETTINGS"></lang>
                    </div>

                    <div class="control" v-if="campaign.type.name != 'LOYALTY_POINTS'">
                        <div class="control-label">
                            <label-name labelKey="PIM-CAMPAIGN-DISCOUNT_TYPE"></label-name>
                        </div>
                        <div class="control" style="width: 100%; max-width: 100%; display: flex; flex-direction: row;">

                            <div style="min-width: 100px;">

                                <p-radio name="discountType" color="primary" value="percent" v-model="campaign.discountType">%-Rabatt</p-radio>

                                <div style="display: flex; align-items: center; margin-top:4px;" :class="campaign.discountType != 'percent' ? 'is-disabled' : ''">
                                    <form-input placeholder="z.B. 10" @keypress.native="isNumber($event)" style="flex-grow: 0; width:80px; margin-right: 4px;" :showLabel="false" inputType="text" :isPointToComma="true" v-model.number="campaign.discountPercent"></form-input>
                                    <span>%</span>
                                </div>

                            </div>

                            <div style="min-width: 80px; text-align: center; font-style:italic; display: flex; align-items: center; justify-content: center;">
                                oder
                            </div>

                            <div style="min-width: 100px;">

                                <p-radio name="discountType" color="primary" value="discount" v-model="campaign.discountType">Wert-Rabatt</p-radio>

                                <div style="display: flex; align-items: center; margin-top:4px;" :class="campaign.discountType != 'discount' ? 'is-disabled' : ''">
                                    <form-input placeholder="z.B. 2" @keypress.native="isNumber($event)" style="flex-grow: 0; width: 80px; margin-right: 4px;" :showLabel="false" inputType="text" :isPointToComma="true" v-model.number="campaign.discount"></form-input>
                                    <span>EUR</span>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="control" v-if="campaign.type.name == 'LOYALTY_POINTS'">
                        <div class="control-label">
                            <label-name labelKey="PIM-CAMPAIGN-LOYALTY_POINTS_DISCOUNT_TYPE"></label-name>
                        </div>
                        <div class="control">
                            <div style="display: flex; align-items: center;">
                                <form-input placeholder="z.B. 2" @keypress.native="isNumber($event)" style="flex-grow: 0; width: 40px; margin-right: 4px;" :showLabel="false" inputType="text" :isPointToComma="true" v-model.number="campaign.discount"></form-input>
                                <span>x Bonuspunkte</span>
                            </div>
                        </div>
                        {{ campaign.discount }}
                    </div>

                    <template v-if="campaign.type.name == 'CART_DISCOUNT'">

                        <div class="control">
                            <div class="control-label">
                                <label-name labelKey="PIM-CAMPAIGN-MINIMUM_ORDER_VALUE"></label-name>
                            </div>
                            <div class="control">

                                <b-switch v-model.sync="campaign.minOrderValue" type="primary" size="small"></b-switch>

                                <div style="display: flex; align-items: center; margin-top:4px;" v-show="campaign.minOrderValue">
                                    <form-input style="flex-grow: 0; width:80px; margin-right: 4px;" :isPointToComma="true" :showLabel="false" inputType="text" v-model="campaign.minTotal"></form-input>
                                    <span>EUR</span>
                                </div>

                            </div>
                        </div>



                    </template>


                </section>

                <!-- PRODUCT SETTINGS -->
                <section v-if="campaign.type.name == 'OFFER_PRICE' || campaign.type.name == 'DISCOUNT' || campaign.type.name == 'LOYALTY_POINTS'">


                    <div class="sectionLabel">
                        <lang labelKey="PIM-CAMPAIGN-SECTION-LABEL-PRODUCT_SETTINGS"></lang>
                    </div>


                    <div class="control">

                        <div class="control-label">
                            <label class="label"><lang labelKey="PIM-CAMPAIGN-PRODUCTS"></lang></label>
                        </div>

                        <div class="control">


                            <div v-for="(p, index) in campaign.products" :key="p" class="bg-light product">
               
                                <div style="flex-grow: 1">

                                    <div style="margin-bottom: 10px;" v-if="p.pimProduct">

                                        <div class="imgWrapper lazy-img-fadein" v-lazy:background-image="$config.assets + p.pimProduct.image"></div>

                                        <div>
                                            <span class="productName">{{ p.pimProduct.name }}</span><br /><span class="productInfo">PZN {{ p.pimProduct.extRef }} | € {{ getProductPrice(p) }}</span>
                                        </div>

                                    </div>

                                    <form-input v-if="campaign.type.name != 'DISCOUNT'" inputType="text" :placeholder="$t( campaign.type.name == 'LOYALTY_POINTS' ? 'PIM-CAMPAIGN-PRODUCT-LOYALTY_POINTS' : 'PIM-CAMPAIGN-PRODUCT-OFFER_PRICE')" @keypress.native="isNumber($event)" v-model.number="p.offerPrice" :isPointToComma="true" :showLabel="false" :label="campaign.type.name == 'LOYALTY_POINTS' ? 'PIM-CAMPAIGN-PRODUCT-LOYALTY_POINTS' : 'PIM-CAMPAIGN-PRODUCT-OFFER_PRICE'"></form-input>

                                </div>

                                <div class="removeButton" @click.prevent="productRemove(p)">

                                    <span class="icon"><i class="icon-ak-entfernen"></i></span>

                                </div>

                            </div>

                            <a class="button" @click.prevent="showProductsModal">
                                <span class="icon is-small"><i class="icon-ak-hinzufuegen"></i></span>
                                <span>Produkt hinzufügen</span>
                            </a>


                        </div>

                    </div>

                    <template v-if="campaign.type.name == 'DISCOUNT' || campaign.type.name == 'LOYALTY_POINTS'">

                        <div class="separator">
                            <span>oder</span>
                        </div>

                        <!-- Produkt Kategorien -->
                        <div class="control">

                            <div class="control-label">
                                <lang labelKey="PIM-CAMPAIGN-PRODUCT_CATEGORIES" class="label"></lang>
                            </div>

                            <div class="control">

                                <treeselect
                                    v-model="campaign.categoryIds"
                                    placeholder="bitte Kategorie(n) auswählen"
                                    :multiple="true"
                                    :loading="categories == null"
                                    :options="categories"
                                    :normalizer="normalizer"
                                    value-consists-of="ALL" v-if="categories != null">
                                </treeselect>

                            </div>

                        </div>


                        <div class="separator">
                            <span>oder</span>
                        </div>

                        <!-- Produkt-Gruppen -->
                        <div class="control">

                            <div class="control-label">
                                <lang labelKey="PIM-CAMPAIGN-CUSTOM_PRODUCT_GROUPS" class="label"></lang>
                            </div>

                            <div class="control">

                                <multiselect
                                    v-if="groups != null"
                                    v-model="groupIdsWrapper"
                                    :options="groups"
                                    :custom-label="customGroupsLabel"
                                    :allow-empty="true"
                                    :multiple="true"
                                    selected-label="aktiv"
                                    deselect-label="Klick um abzuwählen"
                                    select-label="Klick für Auswahl"
                                    placeholder="Bitte Gruppe auswählen"
                                    label="name"
                                    track-by="id"
                                    :optionsLimit="10"
                                    class="small">

                                    <span slot="noOptions">Keine Einträge vorhanden</span>
                                    <span slot="noResult">Ihre Suche ergab leider keine Treffer.</span>

                                </multiselect>

                            </div>

                        </div>

                        <div class="separator">
                            <span>oder</span>
                        </div>

                        <!-- Marken -->
                        <div class="control">

                            <div class="control-label">
                                <lang labelKey="PIM-CAMPAIGN-BRANDS" class="label"></lang>
                            </div>

                            <div class="control">

                                <multiselect
                                    v-if="brands != null"
                                    v-model="brandIdsWrapper"
                                    :options="brands"
                                    :custom-label="customBrandsLabel"
                                    :allow-empty="true"
                                    :multiple="true"
                                    selected-label="aktiv"
                                    deselect-label="Klick um abzuwählen"
                                    select-label="Klick für Auswahl"
                                    placeholder="Bitte Marke(n) auswählen"
                                    label="name"
                                    track-by="id"
                                    :optionsLimit="10"
                                    :loading="brands == null"
                                    class="small">

                                    <span slot="noOptions">Keine Einträge vorhanden</span>
                                    <span slot="noResult">Ihre Suche ergab leider keine Treffer.</span>

                                </multiselect>

                            </div>

                        </div>

                    </template>


                </section>

                <section v-if="campaign.type.name == 'DISCOUNT' || campaign.type.name == 'LOYALTY_POINTS'">

                    <!-- temporary show for "lieblingsapotheke (2987) only -->


                    <div class="sectionLabel">
                        <lang labelKey="PIM-CAMPAIGN-SECTION-LABEL-MIN_QUANTITY"></lang>
                    </div>

                    <div class="control">

                        <div class="control-label">
                            <label class="label"><lang labelKey="PIM-CAMPAIGN-HAS_MIN_QUANTITY"></lang></label>
                        </div>

                        <div class="control">

                        <b-switch label="test" style="margin-bottom:8px;" v-model.sync="campaign.hasMinQuantity" type="primary" size="small" @click.native="changeMinQuantity"></b-switch>

                        <template v-if="campaign.hasMinQuantity">
                            <form-input inputType="text" :placeholder="$t('PIM-CAMPAIGN-OFFER_MIN_QUANTITY')" v-model="campaign.minQuantity" :isPointToComma="true" :showLabel="false" label="PIM-CAMPAIGN-OFFER_MIN_QUANTITY"></form-input>
                        </template>

                        </div>

                    </div>

      
                </section>



                <!-- AEP SETTINGS -->
                <section v-if="campaign.type.name == 'AEP'">
                    <div class="sectionLabel">
                        <lang labelKey="PIM-CAMPAIGN-SECTION-LABEL-AEP"></lang>
                    </div>

                    <div class="control">
                        <div class="control-label">
                            <label-name labelKey="PIM-CAMPAIGN-AEP-SURCHARGE"></label-name>
                        </div>
                        <div class="control" style="display: flex;">

                          <div style="display: flex; flex-direction: column;">
                              <div style="display: flex; align-items: center;">
                                <form-input style="flex-grow: 0; width:80px; margin-right: 4px;" :showLabel="false" inputType="text" :isPointToComma="true" v-model="campaign.discountPercent"></form-input>
                                <span>%</span>
                              </div>
                          </div>

                        </div>
                    </div>

                </section>

                <!-- CUSTOMER SETTINGS (all offer types) -->
                <!-- <section v-if="this.siteId != null && (['DISCOUNT', 'OFFER_PRICE'].indexOf(campaign.type.name) == -1 || (['DISCOUNT', 'OFFER_PRICE'].indexOf(campaign.type.name) > -1 && campaign.hasVoucher))"> -->
                <section v-if="this.siteId != null">

                    <div class="sectionLabel">
                        <lang labelKey="PIM-CAMPAIGN-SECTION-LABEL-CUSTOMER_SETTINGS"></lang>
                    </div>

                    <div class="control">

                        <div class="control-label">
                            <lang labelKey="PIM-CAMPAIGN-CUSTOMER_GROUPS" class="label"></lang>
                        </div>

                        <div class="control">

                          <template v-if="customerGroups != null && customerGroups.length > 0">

                            <multiselect
                                v-model="customerGroupIdsWrapper"
                                :options="customerGroups"
                                :custom-label="customerGroupsLabel"
                                :allow-empty="true"
                                :multiple="true"
                                selected-label="aktiv"
                                deselect-label="Klick um abzuwählen"
                                select-label="Klick für Auswahl"
                                placeholder="Bitte Gruppe auswählen"
                                label="name"
                                track-by="id"
                                :optionsLimit="100"
                                class="small">

                                <span slot="noOptions">Keine Einträge vorhanden</span>
                                <span slot="noResult">Ihre Suche ergab leider keine Treffer.</span>

                            </multiselect>

                          </template>


                        </div>

                    </div>

                </section>

                <!-- FURTHER SETTINGS (all offer types) -->
                <section v-if="campaign.type.name != 'AEP' && campaign.type.name != 'LOYALTY_POINTS'">
                    <div class="sectionLabel">
                        <lang labelKey="PIM-CAMPAIGN-SECTION-LABEL-OTHER_SETTINGS"></lang>
                    </div>

                    <div class="control">
                        <div class="control-label">
                            <label-name labelKey="PIM-CAMPAIGN-IS_NOT_COMBINABLE"></label-name>
                        </div>
                        <div class="control">
                            <b-switch v-model.sync="campaign.isNotCombinable" type="primary" size="small"></b-switch>
                            <div style="margin: 2px 0 0 0; font-size: 12px; color: #888;"><lang labelKey="PIM-CAMPAIGN-NOT_COMBINABLE-NOTICE"></lang></div>
                        </div>
                    </div>

                </section>

                <custom-button icon="icon-ak-speichern" :loading="isSaving" name="PIM-CAMPAIGN-BTN-SAVE" type="blue" @click.native="save"></custom-button>

            </template>

        </div>



        <modal
            title="Produkte"
            transition="fadeDown"
            :is-show="showModal"
            :backdrop-closable="false"
            :show-footer="true"
            @close="closeModal"
            class="vcenter pimModal">

                <pim-products
                    v-if="showModal"
                    :allowSelection="true"
                    :allowDelete="false"
                    :allowEditName="false"
                    :allowEditProduct="false"
                    :showPharmacyFilter="false"
                    :showPagination="false"
                    :showFilters = "['filterPackageLeaflet', 'filterCategory', 'filterIncomplete', 'filterMultiple', 'filterVariableProduct', 'filterIsDrug', 'filterImage']"
                    :preselectedProducts = "campaign.products.map(_ => parseInt(_.pimProduct.id))"
                    @selectedRows="selectProducts">
                </pim-products>

                <template slot="footer">
                    <a class="button" @click.prevent.parent="closeModal">Abbrechen</a>
                    <a :class="['button is-primary', { 'is-disabled': productsSelected.length == 0 }]" @click.prevent.parent="assignProducts">Übernehmen</a>
                </template>

        </modal>


    </div>


</template>

<script>
import Vue from 'vue';
import { de } from 'flatpickr/dist/l10n/de';
de.firstDayOfWeek = 1; // Monday

import PrettyCheckbox from 'pretty-checkbox-vue';
Vue.use(PrettyCheckbox);


// import the component
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'


import pimProducts from '../incl-pimProducts';
import { compareDates } from "./utils";

export default {

    components: {
        pimProducts,
        Treeselect
    },

    data () {

        return {

            isLoading: false,
            isSaving: false,

            campaign: null,

            productsSelected: [],

            customerGroups: null,

            groups: null,
            brands: null,
            categories: null,

            showModal: false,

            datePickerOptions: {
                enableTime: false,
                time_24hr: true,
                enableSeconds: false,
                altInput: true,
                // altFormat: 'd. F Y  - H:i',
                altFormat: 'd. F Y',
                locale: de,
                clickOpens: true,
                weekNumbers: true
            },
        }

    },


    computed: {

        pageTitle() {
            return this.campaign == null ? 'PIM-CAMPAIGN-TITLE' : 'PIM-CAMPAIGN-TYPE-'+this.campaign.type.name;
        },

        campaignStatus() {
          return this.$store.getters.getTermsByTaxonomy('APOPOINT_OFFER_STATUS');
        },

        pharmacySelected() {
            return this.$store.getters.getPIMPharmacy;
        },

        siteId() {
            return this.activeUser.site == null ? null : this.activeUser.site.id;
        },

        offerCategories() {
            return this.$store.getters.getTermsByTaxonomy('APOPOINT_OFFER_CATEGORY');
        },

        brandIdsWrapper: {

            get() {

                if(this.brands == null || this.campaign.brandIds.length == 0) {
                    return;
                }

                return this.campaign.brandIds.map(b => this.brands.find(_ => _.id == b));
            },

            set(val) {

                this.campaign.brandIds = [];
                if(val.length == 0) {
                    return;
                }
                this.campaign.brandIds = val.map(_ => _.id);
            }

        },

        groupIdsWrapper: {

            get() {
                if(this.groups == null || this.campaign.productGroupIds.length == 0) {
                    return;
                }
                return this.campaign.productGroupIds.map(b => this.groups.find(_ => _.id == b));
            },

            set(val) {
                this.campaign.productGroupIds = [];
                if(val.length == 0) {
                    return;
                }
                this.campaign.productGroupIds = val.map(_ => _.id);
            }

        },

        customerGroupIdsWrapper: {

            get() {
                if(this.customerGroups == null || this.campaign.customerGroupIds.length == 0) {
                    return;
                }

                return this.campaign.customerGroupIds.map(b => this.customerGroups.find(_ => _.id == b));

            },

            set(val) {
                this.campaign.customerGroupIds = [];
                if(val.length == 0) {
                    return;
                }
                this.campaign.customerGroupIds = val.map(_ => _.id);
            }

        },



    },


    created() {

        if(this.$route.params.id) {
            this.fetchData(this.$route.params.id);
        }

    },

    watch: {

        "campaign.hasVoucher"(val) {

            if(val == false) {
                this.campaign.voucherCode = null;
            }

        },

        "campaign.minOrderValue"(val) {

            if(val == false) {
                this.campaign.minTotal = null;
            }

        },

        "campaign.discountType"(val) {

            if(val == 'discount') {
                this.campaign.discountPercent = null;
            } else {
                this.campaign.discount = null;
            }

        },

    },

    methods: {

        isNumber(event) {
          if (!/\d/.test(event.key) && event.key !== '.' && event.key !== ',') {
            return event.preventDefault();
          }
        },

        changeMinQuantity() {

          if(this.campaign.hasMinQuantity == false) {
            this.campaign.minQuantity = null;
          }

        },

        getProductPrice(product) {

            // console.log(product);

            // priceSite = der Preis den die Apotheke für sich gepflegt hat anstatt des Herba-Preises und
            // priceOfferSite = der Angebotspreis der aus dem ERP der Apotheke kommt
            // Ich denke wir sollten nach Priorität priceOfferSite -> priceSite -> price darstellen.

            // let price = 0;

            let price = this.formatPoint2Comma(product.pimProduct.price);


            if(product.pimProduct.priceOfferSite && product.pimProduct.priceOfferSite != null) {
                price += ' (Schnittstelle1: €' + this.formatPoint2Comma(product.pimProduct.priceOfferSite) + ')';
            }

            return price;

        },


        normalizer(node) {

            return {
                id: node.id,
                label: node.name,
                children: node.children
            }

        },

        customCategoryLabel({name}) {
            return this.$t('PIM-CAMPAIGN-CATEGORY-'+name);
        },

        customGroupsLabel({name}) {
            return name;
        },

        customerGroupsLabel({name}) {
            return name;
        },

        customBrandsLabel({ name }) {
            return name;
        },

        showProductsModal() {
            this.showModal = true;
        },

        productRemove(product) {

            let foundIndex = this.campaign.products.findIndex(_ => _.pimProduct.id == product.pimProduct.id);

            if(foundIndex != -1) {
                this.campaign.products.splice(foundIndex, 1);
            }

        },

        assignProducts() {

            this.productsSelected.forEach(p => {

                this.campaign.products.push({
                    pimProduct: p,
                    offer: this.$route.params.id,
                    offerPrice: null
                })

            })

            this.productsSelected = [];
            this.closeModal();

        },

        selectProducts(products) {

            this.productsSelected = products;

        },


        closeModal() {

            this.showModal = false;

        },

        makeid(length=8) {

            var result           = '';
            // var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
            var charactersLength = characters.length;
            for ( var i = 0; i < length; i++ ) {
                result += characters.charAt(Math.floor(Math.random() * charactersLength));
            }

            this.campaign.voucherCode = result;

        },


        save() {


            if(this.campaign.hasVoucher) {

                if(this.campaign.voucherCode == null || this.campaign.voucherCode == '') {

                    this.$notify.open({ content: 'Bitte geben Sie einen Gutschein-Code ein!', type: 'warning' });
                    return;

                } else {

                    // at least 3 characters long
                    if(this.campaign.voucherCode.trim().length < 3) {
                        this.$notify.open({ content: 'Der Gutschein-Code darf muss mindestens 3 Zeichen haben!', type: 'warning' });
                        return;
                    }

                    // only 0-9a-zA-Z allowed
                    if(!this.campaign.voucherCode.match(/^[0-9a-zA-Z]+$/)) {
                        this.$notify.open({ content: 'Der Gutschein-Code darf nur aus Klein,-Großbuchstaben und Zahlen bestehen!', type: 'warning' });
                        return;
                    }

                }

            }

            // ANGEBOTS-PREISE
            if(this.campaign.type.name == 'OFFER_PRICE') {

                if(this.campaign.products.length == 0) {
                    this.$notify.open({ content: 'Bitte wählen Sie mindestens ein Produkt aus!', type: 'warning' });
                    return;
                }

                let forgottenPrice = this.campaign.products.some(p => (p.offerPrice == null || p.offerPrice == ''));

                if(forgottenPrice) {
                    this.$notify.open({ content: 'Bitte geben Sie bei jedem Produkt einen Aktionspreis ein!', type: 'warning' });
                    return;
                }


                let invalidPrice = this.campaign.products.some(p => Number(p.pimProduct.price) < Number(p.offerPrice));

                if(invalidPrice) {
                    this.$notify.open({ content: 'Der Aktionspreis muss kleiner als der reguläre Preis sein!', type: 'warning' });
                    return;
                }

            }

            else if(this.campaign.type.name == 'DISCOUNT' || this.campaign.type.name == 'CART_DISCOUNT' || this.campaign.type.name == 'LOYALTY_POINTS') {

                if(this.campaign.type.name != 'LOYALTY_POINTS') {

                    if(this.campaign.discountType == 'percent' && (this.campaign.discountPercent == null || this.campaign.discountPercent == "")) {
                        this.$notify.open({ content: 'Bitte geben Sie einen %-Rabatt ein!', type: 'warning' });
                        return;
                    }
                    else if(this.campaign.discountType == 'discount' && (this.campaign.discount == null || this.campaign.discount == "")) {
                        this.$notify.open({ content: 'Bitte geben Sie einen Wert-Rabatt ein!', type: 'warning' });
                        return;
                    }
                }

                // WARENKORB RABATTE
                if(this.campaign.type.name == 'CART_DISCOUNT') {

                    if(this.campaign.minOrderValue && (this.campaign.minTotal == null || this.campaign.minTotal == "")) {
                        this.$notify.open({ content: 'Bitte geben Sie einen Mindestbestellwert ein!', type: 'warning' });
                        return;
                    }

                }

                // PRODUKT RABATTE
                else if(this.campaign.type.name == 'DISCOUNT') {

                    // one "product setting" must be selected
                    if(this.campaign.products.length == 0
                        && this.campaign.brandIds.length == 0
                        && this.campaign.categoryIds.length == 0
                        && this.campaign.productGroupIds.length == 0) {
                            this.$notify.open( { content: 'Bitte wählen Sie eine Einschränkung unter "Produkt Einstellungen" aus!', type: 'warning'});
                            return;
                        }

                    // only one "product setting" must be selected
                    else {

                        if(this.campaign.products.length > 0
                            && (this.campaign.brandIds.length != 0 || this.campaign.categoryIds.length != 0 || this.campaign.productGroupIds.length != 0)) {
                                this.$notify.open( { content: 'Es darf nur eine eine Einschränkung unter "Produkt Einstellungen" gewählt sein!', type: 'warning'});
                                return;
                            }

                        else if(this.campaign.brandIds.length > 0
                            && (this.campaign.products.length != 0 || this.campaign.categoryIds.length != 0 || this.campaign.productGroupIds.length != 0)) {
                                this.$notify.open( { content: 'Es darf nur eine eine Einschränkung unter "Produkt Einstellungen" gewählt sein!', type: 'warning'});
                                return;
                            }

                        else if(this.campaign.categoryIds.length > 0
                            && (this.campaign.products.length != 0 || this.campaign.brandIds.length != 0 || this.campaign.productGroupIds.length != 0)) {
                                this.$notify.open( { content: 'Es darf nur eine eine Einschränkung unter "Produkt Einstellungen" gewählt sein!', type: 'warning'});
                                return;
                            }
                        else if(this.campaign.productGroupIds.length > 0
                            && (this.campaign.products.length != 0 || this.campaign.brandIds.length != 0 || this.campaign.categoryIds.length != 0)) {
                                this.$notify.open( { content: 'Es darf nur eine eine Einschränkung unter "Produkt Einstellungen" gewählt sein!', type: 'warning'});
                                return;
                            }
                    }
                }

            }

            // GRATIS LIEFERUNG
            else if(this.campaign.type.name == 'FREE_DELIVERY') {


            }

            // AEP
            else if(this.campaign.type.name == 'AEP') {

              if(!this.campaign.discountPercent || this.campaign.discountPercent && this.campaign.discountPercent == "") {
                this.$notify.open( { content: 'Bitte geben Sie einen Wert für den AEP-Aufschlag ein!', type: 'warning'});
                return;
              }
              else if(this.campaign.discountPercent && isNaN(this.campaign.discountPercent)) {
                this.$notify.open( { content: 'Die Eingabe bei AEP-Zuschlag ist ungültig. Bitte geben Sie eine valide Zahl ein!', type: 'warning'});
                return;
              }

              if(this.campaign.customerGroupIds.length == 0) {
                this.$notify.open( { content: 'Bitte wählen Sie eine Kundengruppe aus!', type: 'warning'});
                return;
              }

            }

            // if campaign type is "loayltyPoints", we want "discount" as discountType only
            if(this.campaign.type.name === 'LOYALTY_POINTS') {
                this.campaign.discountType = 'discount';
            }

            if(this.campaign.discountType == 'percent') {

                this.campaign.discount = null;

            } else if(this.campaign.discountType == 'discount') {

                this.campaign.discountPercent = null;

            }

            // let saveObj = this.campaign;
            this.isSaving = true;

            this.axios.put(this.$config.api + 'apopointOffer/'+this.campaign.id, this.campaign).then(res => {

                this.$notify.open({ content: 'Aktion erfolgreich gespeichert!', type: 'success' });
                this.isSaving = false;
                
                // route back to list
                this.$router.back();

            }).catch(err => {
                console.log("err: ", err);
            })

        },


        fetchData(id) {

            this.isLoading = true;

            this.categoriesSelected = null;

            this.axios
              .get(this.$config.api + 'apopointOffer/'+id+'?include=apopointOffer.category,apopointOffer.products,apopointOfferProduct.pimProduct,apopointOffer.type,apopointOffer.status')
              .then(res => {

                res.data.hasVoucher = res.data.voucherCode != null;
                res.data.discountType = res.data.discount != null && res.data.discount != "" ? 'discount' : 'percent';
                res.data.minOrderValue = res.data.minTotal != null && res.data.minTotal != "" ? true : false;

                // make sure to filter group ids with value "null";
                res.data.customerGroupIds = res.data.customerGroupIds.filter((g) => g != null);

                if(res.data.minQuantity && res.data.minQuantity > 0) {
                  res.data.hasMinQuantity = true;
                }

                // set campaign to status "DRAFT" when the validTo date is older then the current date
                const today = new Date();
                const isArchive = compareDates(res.data.validTo ? new Date(res.data.validTo) : null, today, '<');
                
                // if this is an "archived" item, we set its status to DRAFT;
                if(isArchive) {
                    res.data.status = this.campaignStatus.DRAFT;
                }

                if(this.siteId != null) {

                  const foo = async () => {
                    await this._loadCustomerGroups().then(res => {
                      this.customerGroups = res.data.apopointCustomerGroup.filter(g => g.site == this.siteId);
                    })
                  }

                  foo();
                }


                // load categories in case we've to handle a "discount"
                if(res.data.type.name == 'DISCOUNT' || res.data.type.name == 'LOYALTY_POINTS') {

                    (async() => {

                        await this._loadGroups().then(res => {
                            this.groups = res.data.apopointProductGroup;
                        })

                        await this._loadCategories().then(res => {
                            this.categories = res.data;
                        })

                        await this._loadBrands().then(res => {
                            this.brands = res.data.pimBrand;
                        })

                        this.campaign = res.data;
                        this.isLoading = false;

                    })()

                } else {

                    this.campaign = res.data;
                    // this.campaign.type.name = 'AEP';
                    this.isLoading = false;

                }

            })

        },

        _loadBrands() {
            return this.axios.get(this.$config.api + 'pimBrand?orderBy=name&filters[name]=!');
        },

        _loadGroups() {
            return this.axios.get(this.$config.api + 'apopointProductGroup?include=apopointProductGroup.products&filters[site]='+this.siteId);
        },

        _loadCategories() {
            return this.axios.get(this.$config.api + 'pimCategory/tree' + (this.pharmacySelected != null && this.pharmacySelected.id ? '?site='+this.pharmacySelected.id : ''));
        },

        _loadCustomerGroups() {
            return this.axios.get(this.$config.api + 'apopointCustomerGroup');
        },
    }

}
</script>
<style lang="scss">

    @import '~pretty-checkbox/src/pretty-checkbox.scss';
    .p-default {
        margin: 0;
    }

</style>

<style lang="scss" scoped>

    .separator {
        display: flex;
        align-items: center;
        text-align: center;
        max-width: 800px;
        color: #666;
        text-transform: uppercase;
        font-size: 12px;
        font-weight: bold;
        padding: 12px 0 12px 180px;
        margin-bottom: 15px;
    }

    ::v-deep .vue-treeselect__multi-value-item {
        color: #000;
        background: #F5F7F9;
    }
    ::v-deep .vue-treeselect__value-remove {
        color: #aaa;
    }

    .pimModal {

        ::v-deep .modal-card {
            min-width: 640px;
            max-width: 90%;
            width: 100%;
            max-height: 95vh;
            overflow: hidden;
        }

    }

    .bg-light {
        padding: 20px 14px;
        background: #F5F7F9;
        /*margin: 5px -30px 20px -30px;*/
        &.rounded {
            border-radius: 4px;
        }
        &.grey {
            background-color: #F1F1F1;
        }
        &.is-published {
            background-color: #f5f9f5;
        }
    }
    .centered {
        max-width: 700px;
        width: 100%;
        margin: 0 auto;
    }


    section {

        div.sectionLabel {
            font-size: 20px;
            margin-bottom: 32px;
        }

        padding: 20px;

        margin-bottom: 15px;
        border-bottom: 2px solid #F5F7F9;


        .control {

            display: flex;
            max-width: 800px !important;
            min-width: 100px;

            &.grey {

                ::v-deep .control {
                    margin-bottom: 0 !important;
                }
            }


            .multiselect {
                max-width: 100% !important;
                margin-bottom: 0 !important;
            }

            ::v-deep .control-label {
                flex-grow: 0 !important;
                flex-basis: 180px !important;
                margin: 0;
                padding: 0;
            }

            ::v-deep .control {
                display: block;
                flex-grow: 1;
                max-width: none;
                margin-bottom: 10px !important;
                min-width: 100px;
/*
                &:last-child {
                    margin-bottom: 0 !important;
                }
*/
            }

        }
    }

    .product {

        display: flex;
        padding: 14px 10px;
        max-width: 800px;
        border-radius: 4px;
        margin: 0 0 8px 0;

        .imgWrapper {
            float: left;
            width: 42px;
            height: 42px;
            margin-right: 12px;
            background-position: 50% 50%;
            background-repeat: no-repeat;
            background-size: contain;

            &[lazy=loading]  {
                background-size: 30% !important;
            }
            &[lazy=error]  {
                background-image: none !important;
            }

        }

        .productName {
            color: #000;
            font-size: 14px;
        }
        .productInfo {
            font-size: 12px;
        }


        .removeButton {

            display: flex;
            align-items: center;
            padding: 0 14px;
            margin: -14px -10px -14px 10px;
            border-left: 1px dotted #D0D0D0;
            border-top-right-radius: 4px;
            border-bottom-right-radius: 4px;
            cursor: pointer;


            .icon {
                margin: 0;
                i {
                    color: #AAA;
                    font-size: 14px;
                    transition: all .3s ease;
                }
            }

            transition: all .3s ease;

            &:hover {

                background-color: #EEE;

                .icon {
                    i {
                        color: #000;
                    }
                }
            }
        }

    }

    .divider {
        padding-top: 20px;
        margin-bottom: 15px;
        border-bottom: 2px solid #F5F7F9;
    }

    @media all and (max-width: 860px) {

        section {

            .control {

                flex-wrap: wrap;


                ::v-deep .control-label {
                    flex-grow: 1 !important;
                    flex-basis: 100% !important;
                    margin: 0 0 4px 0;
                    padding: 0;
                }

                ::v-deep .control {
                    display: block;
                    flex-grow: 1;
                    max-width: none;
                }


            }
        }

    }

</style>
